import {
  Facebook,
  Instagram,
  Send,
  Briefcase,
  Globe,
  Users,
  Edit3,
  HelpCircle,
} from "lucide-react";
import { Badge } from "@/components/ui/Badge";
import type { LeadSource } from "@/modules/sales/types";

/**
 * LeadSourceBadge — lead manbasi ikonkasi+matni.
 * Dizayn yo'riqnoma § 1.3.
 */
interface LeadSourceBadgeProps {
  source: LeadSource | string | null | undefined;
  size?: "sm" | "md" | "lg";
  showLabel?: boolean;
  className?: string;
}

const SOURCE_LABEL: Record<string, string> = {
  META_ADS: "Meta",
  INSTAGRAM: "Instagram",
  TELEGRAM: "Telegram",
  AMOCRM: "AmoCRM",
  WEBSITE: "Website",
  REFERRAL: "Referal",
  MANUAL: "Manual",
  OTHER: "Other",
};

const SOURCE_ICON: Record<string, typeof Facebook> = {
  META_ADS: Facebook,
  INSTAGRAM: Instagram,
  TELEGRAM: Send,
  AMOCRM: Briefcase,
  WEBSITE: Globe,
  REFERRAL: Users,
  MANUAL: Edit3,
  OTHER: HelpCircle,
};

const SOURCE_CLASS: Record<string, string> = {
  META_ADS: "bg-[var(--source-meta-bg)] text-[var(--source-meta-fg)] border-[var(--source-meta-border)]",
  INSTAGRAM: "bg-[var(--source-instagram-bg)] text-[var(--source-instagram-fg)] border-[var(--source-instagram-border)]",
  TELEGRAM: "bg-[var(--source-telegram-bg)] text-[var(--source-telegram-fg)] border-[var(--source-telegram-border)]",
  AMOCRM: "bg-[var(--source-amocrm-bg)] text-[var(--source-amocrm-fg)] border-[var(--source-amocrm-border)]",
  WEBSITE: "bg-[var(--source-website-bg)] text-[var(--source-website-fg)] border-[var(--source-website-border)]",
  REFERRAL: "bg-[var(--source-referral-bg)] text-[var(--source-referral-fg)] border-[var(--source-referral-border)]",
  MANUAL: "bg-[var(--source-manual-bg)] text-[var(--source-manual-fg)] border-[var(--source-manual-border)]",
  OTHER: "",
};

export function LeadSourceBadge({
  source,
  size = "sm",
  showLabel = true,
  className,
}: LeadSourceBadgeProps) {
  const key = (source ?? "OTHER") as keyof typeof SOURCE_ICON;
  const Icon = SOURCE_ICON[key] ?? HelpCircle;
  const label = SOURCE_LABEL[key] ?? "Other";
  const variantCls = SOURCE_CLASS[key] ?? "";

  return (
    <Badge size={size} className={`${variantCls} ${className ?? ""}`}>
      <Icon className="h-3 w-3" aria-hidden />
      {showLabel ? label : null}
    </Badge>
  );
}
